(function () {
    'use strict';

    angular.module("imApp").factory("orderPickViewService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3711,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
